import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAccountNumber } from "@urp/store-selectors";

import Poller from "@tvg/poller";
import { fetchUserFavoriteTracks } from "../utils/userFavorites";
import { clearUserFavoriteTracks } from "../redux/actions/userFavorites";
import { FAVORITES_POLLER_INTERVAL } from "../constants";

export default () => {
  const accountNumber = useSelector(getAccountNumber);
  const dispatch = useDispatch();

  useEffect(() => {
    const poller = new Poller();

    if (accountNumber) {
      poller.start(
        () => fetchUserFavoriteTracks(accountNumber, dispatch),
        FAVORITES_POLLER_INTERVAL
      );
    } else {
      dispatch(clearUserFavoriteTracks());
    }

    return () => {
      poller.stop();
      dispatch(clearUserFavoriteTracks());
    };
  }, [accountNumber]);
};
